<template>
  <div>
    <!-- 一键开票弹框 -->
    <el-dialog title="开票" :visible="kaiPiaoMark" :close-on-click-modal="false" width="650px" center @close="closeDialog">
      <div class="addressBox">
        <div style="width:80%;margin:0 auto;">
          <el-form :inline="true" :rules="rules" :model="kaiPiaoFrom" ref="kaiPiaoFrom" class="demo-form-inline" label-width="130px" size="small">
            <el-form-item label="开票金额:">
              <span style="color:red;font-size:18px;margin-right:5px;">{{kaiPiaoFrom.invoiceAmount}}</span><span>元</span>
            </el-form-item>
            <el-form-item label="发票号码:" prop="invoiceNo">
              <el-input placeholder="" maxlength="50" v-model.trim="kaiPiaoFrom.invoiceNo" style="width:230px;"></el-input>
            </el-form-item>
            <el-form-item label="开票时间:" prop="invoiceTime">
              <el-date-picker
                v-model="kaiPiaoFrom.invoiceTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="发票图片:" v-if="kaiPiaoMark">
              <uploadFiles style="width:300px;" :fileArr.sync='imgList' :max='1' @change='imgPreview' @remove='handleRemove' @handlePicPreview = 'handlePicPreview' v-if="kaiPiaoMark"></uploadFiles>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="kaiPiaoSubmitFn('kaiPiaoFrom')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { allInvoiceForYs, wayInvoiceForYs } from '@/api/newTMS'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
export default {
  components: {
    uploadFiles
  },
  props: {
    kaiPiaoMark: {
      type: Boolean,
      default: false
    },
    kaiPiaoFrom: {
      type: Object,
      default: function () {
        return {}
      }
    },
    detilsFlag: {
      type: Boolean,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      imgList: [],
      rules: {
        invoiceNo: [
          { required: true, message: '请输入发票号码', trigger: 'blur' }
        ],
        invoiceTime: [
          { required: true, message: '请选择开票时间', trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
    // console.log(this.kaiPiaoFrom,'this.kaiPiaoFrom')
  },
  methods: {
    imgPreview (data) {
      // console.log('传', data)
      this.imgList = data
    },
    handleRemove (data) {
      console.log('data---', data)
      // this.contractDelID = []
      // if (data.id) {
      //   this.contractDelID.push(data.id)
      // }
    },
    handlePicPreview (file) {
      window.open(file.url)
    },
    closeDialog () {
      this.$emit('update:kaiPiaoMark', false)
      this.$refs.kaiPiaoFrom.resetFields()
    },
    kaiPiaoSubmitFn (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          if (this.imgList.length > 0) {
            for (var i = 0; i < this.imgList.length; i++) {
              let a = i
              imgfile.append('files', this.imgList[i].raw)
              if (a == this.imgList.length - 1) {
                imgfile.set('params', JSON.stringify(this.kaiPiaoFrom))
                if (this.detilsFlag) {
                  this.wayInvoiceYs(imgfile)
                } else {
                  this.allInvoiceForYs(imgfile)
                }
              }
            }
          } else {
            // this.$alert('请选择文件图', '系统提示')
            imgfile.set('params', JSON.stringify(this.kaiPiaoFrom))
            if (this.detilsFlag) {
              this.wayInvoiceYs(imgfile)
            } else {
              this.allInvoiceForYs(imgfile)
            }
          }
        } else {
          return false
        }
      })
    },
    // 账单页面一键开票
    allInvoiceForYs (imgfile) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      allInvoiceForYs(imgfile).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.$emit('update:kaiPiaoMark', false)
        this.$emit('refresh')
        this.$refs.kaiPiaoFrom.resetFields()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 账单详情页面点击开票
    wayInvoiceYs (imgfile) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      wayInvoiceForYs(imgfile).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.$emit('update:kaiPiaoMark', false)
        this.$emit('refresh')
        this.$refs.kaiPiaoFrom.resetFields()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    }
  }
}
</script>
<style scoped>

</style>
